import { ActionContext } from 'vuex';
import IndexService from '@/services/balance/index.service';

interface State {
  balance: number;
}

const state: State = {
  balance: 0,
};

const mutations = {
  SET_BALANCE(state: State, balance: number) {
    state.balance = balance;
  },
};

const actions = {
  async fetchBalance({ commit }: ActionContext<State, any>) {
    try {
      const res = await IndexService.getBalance(1);
      if (res.status === 'success') {
        commit('SET_BALANCE', res.result);
      }
    } catch (error) {
      commit('SET_BALANCE', 0);
      console.error('Error fetching balance:', error);
    }
  },
};

const getters = {
  balance: (state: State) => state.balance,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
